// Local mock data used when the site is loaded in demo mode (?demo=true).
// Shapes here mirror exactly what the real API returns, so every theme
// component renders the same way it would against live data.

function placeholderImage(label, w = 800, h = 500) {
  // Double-quoted SVG attributes: encodeURIComponent escapes " (to %22) but
  // leaves ' unescaped, and a literal ' breaks unquoted CSS url(...) usage
  // (e.g. Hero's backgroundImage), even though it's fine inside <img src>.
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}">` +
    `<rect width="100%" height="100%" fill="#e5e7eb"/>` +
    `<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" ` +
    `font-family="Arial, sans-serif" font-size="28" fill="#6b7280">${label}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export const startPoint = {
  user_id: 1,
  website: { id: 1, request_status: 'approved', is_published: true },
  theme: 'theme1',
};

export const navigation = {
  logo: { imageUrl: '/images/logo-demo.png', text: 'Dealer Auto Sales', link: '/' },
  menu: [
    { id: 1, label: 'Home', to: '/' },
    { id: 2, label: 'Inventory', to: '/inventory' },
    { id: 3, label: 'Financing', to: '/finance' },
    { id: 4, label: 'Contact Us', to: '/contact' },
    { id: 5, label: 'About Us', to: '/about-us' },
    { id: 6, label: 'Terms & Conditions', to: '/terms-and-conditions' },
    { id: 7, label: 'Privacy Policy', to: '/privacy-policy' },
  ],
  copyright: `© ${new Date().getFullYear()} Dealer Auto Sales. All rights reserved.`,
  primary_color: '#4A90E2',
  secondary_color: '#F3F8FF',
};

export const sliders = [
  {
    id: 1,
    is_active: true,
    sort_order: 1,
    image_url: '/images/hero/hero1.jpg',
    image_alt_text: 'Showroom',
    heading: 'Find Your Perfect Vehicle',
    subheading: 'Quality pre-owned cars at unbeatable prices',
  },
  {
    id: 2,
    is_active: true,
    sort_order: 2,
    image_url: '/images/hero/hero2.jpg',
    image_alt_text: 'Dealership lot',
    heading: 'Financing Made Easy',
    subheading: 'Get pre-qualified in minutes',
  },
  {
    id: 3,
    is_active: true,
    sort_order: 3,
    image_url: '/images/hero/hero3.jpg',
    image_alt_text: 'Vehicle on the lot',
    heading: 'Every Budget Welcome',
    subheading: 'Browse our full inventory today',
  },
];

export const vehicles = [
  { id: 101, year: 2021, make: 'Honda', model: 'Accord', bodyType: 'Sedan', bodyStyle: 'Sedan', color: 'Silver', fuelType: 'Gasoline', mileage: 32000, transmission: 'Automatic', sellPrice: 24500, sell_price: 24500, price: 24500, image: '/images/cars/accord.jpg', images: ['/images/cars/accord.jpg'], description: 'One owner, clean title, well maintained. Recent service record available.', ownership: '1 Owner' },
  { id: 102, year: 2020, make: 'Toyota', model: 'RAV4', bodyType: 'SUV', bodyStyle: 'SUV', color: 'Blue', fuelType: 'Gasoline', mileage: 41000, transmission: 'Automatic', sellPrice: 27800, sell_price: 27800, price: 27800, image: '/images/cars/camry.jpg', images: ['/images/cars/camry.jpg'], description: 'AWD, backup camera, low mileage for its year.', ownership: '2 Owners' },
  { id: 103, year: 2019, make: 'Ford', model: 'F-150', bodyType: 'Truck', bodyStyle: 'Truck', color: 'Black', fuelType: 'Gasoline', mileage: 58000, transmission: 'Automatic', sellPrice: 32900, sell_price: 32900, price: 32900, image: '/images/cars/mustang.jpg', images: ['/images/cars/mustang.jpg'], description: 'Crew cab, towing package, well-kept work truck.', ownership: '1 Owner' },
  { id: 104, year: 2022, make: 'Tesla', model: 'Model 3', bodyType: 'Sedan', bodyStyle: 'Sedan', color: 'White', fuelType: 'Electric', mileage: 15000, transmission: 'Automatic', sellPrice: 38900, sell_price: 38900, price: 38900, image: '/images/cars/mercedes.jpg', images: ['/images/cars/mercedes.jpg'], description: 'Long range battery, autopilot included.', ownership: '1 Owner' },
  { id: 105, year: 2018, make: 'Chevrolet', model: 'Equinox', bodyType: 'SUV', bodyStyle: 'SUV', color: 'Red', fuelType: 'Gasoline', mileage: 67000, transmission: 'Automatic', sellPrice: 18500, sell_price: 18500, price: 18500, image: '/images/cars/malibu.jpg', images: ['/images/cars/malibu.jpg'], description: 'Great family SUV, recently serviced.', ownership: '2 Owners' },
  { id: 106, year: 2023, make: 'Honda', model: 'Civic', bodyType: 'Sedan', bodyStyle: 'Sedan', color: 'Gray', fuelType: 'Gasoline', mileage: 8000, transmission: 'Automatic', sellPrice: 23900, sell_price: 23900, price: 23900, image: '/images/cars/altima.jpg', images: ['/images/cars/altima.jpg'], description: 'Like-new condition, remainder of factory warranty.', ownership: '1 Owner' },
  { id: 107, year: 2017, make: 'BMW', model: '3 Series', bodyType: 'Sedan', bodyStyle: 'Sedan', color: 'Black', fuelType: 'Gasoline', mileage: 72000, transmission: 'Automatic', sellPrice: 19900, sell_price: 19900, price: 19900, image: '/images/cars/bmw.jpg', images: ['/images/cars/bmw.jpg'], description: 'Sport package, leather interior.', ownership: '3 Owners' },
  { id: 108, year: 2020, make: 'Jeep', model: 'Wrangler', bodyType: 'SUV', bodyStyle: 'SUV', color: 'Green', fuelType: 'Gasoline', mileage: 35000, transmission: 'Manual', sellPrice: 33500, sell_price: 33500, price: 33500, image: '/images/cars/sonata.jpg', images: ['/images/cars/sonata.jpg'], description: 'Removable top, off-road package.', ownership: '1 Owner' },
];

export const featuredVehicles = vehicles.slice(0, 6);

export const filterOptions = {
  make: [...new Set(vehicles.map((v) => v.make))],
  year: [...new Set(vehicles.map((v) => String(v.year)))],
  fuelType: [...new Set(vehicles.map((v) => v.fuelType))],
  bodyStyle: [...new Set(vehicles.map((v) => v.bodyStyle))],
  price: ['Under $20,000', '$20,000 - $30,000', 'Over $30,000'],
};

export const whyBuyFeatures = [
  { id: 1, title: 'Flexible Financing', description: 'We work with all credit types to get you approved.' },
  { id: 2, title: 'Fair Trade-In Value', description: 'Get top dollar for your current vehicle.' },
  { id: 3, title: 'Extended Warranty', description: 'Peace of mind with every purchase.' },
  { id: 4, title: 'Certified Pre-Owned', description: 'Every vehicle passes a rigorous inspection.' },
  { id: 5, title: 'Same-Day Delivery', description: "Drive away the same day you're approved." },
  { id: 6, title: 'Expert Support', description: 'Our team is here to help before and after the sale.' },
];

export const contact = {
  contact_phone: '(555) 123-4567',
  contact_address: '123 Main Street\nSpringfield, ON L9T 1A1',
  contact_email: 'sales@dealerautosales.com',
  contact_email_2: 'service@dealerautosales.com',
};

export const socialLinks = [
  { platform: 'facebook', url: 'https://facebook.com/dealerautosales', is_active: true, display_order: 1 },
  { platform: 'instagram', url: 'https://instagram.com/dealerautosales', is_active: true, display_order: 2 },
  { platform: 'youtube', url: 'https://youtube.com/@dealerautosales', is_active: true, display_order: 3 },
];

export const businessHours = {
  hours: {
    monday: '9:00 AM - 6:00 PM',
    tuesday: '9:00 AM - 6:00 PM',
    wednesday: '9:00 AM - 6:00 PM',
    thursday: '9:00 AM - 6:00 PM',
    friday: '9:00 AM - 6:00 PM',
    saturday: '10:00 AM - 4:00 PM',
    sunday: 'Closed',
  },
};

export const contactForm = {
  fields: [
    { key: 'name', label: 'Full Name', type: 'text', required: true },
    { key: 'email', label: 'Email', type: 'email', required: true },
    { key: 'phone', label: 'Phone', type: 'tel', required: false },
    { key: 'subject', label: 'Subject', type: 'select', required: false, options: { options: ['Sales', 'Service', 'Parts', 'General Inquiry'] } },
    { key: 'message', label: 'Message', type: 'textarea', required: true, description: 'How can we help you?' },
    { key: 'subscribe', label: 'Subscribe to newsletter', type: 'checkbox', required: false },
  ],
};

export const pageContent = {
  type: 'page',
  content: {
    title: 'About Dealer Auto Sales',
    image: placeholderImage('About Us', 1200, 600),
    intro: { heading: 'Our Story', description: 'Founded in 2010, Dealer Auto Sales has been serving the community with quality pre-owned vehicles ever since.' },
    tableOfContents: ['Our Story', 'Our Mission', 'Meet the Team'],
    sections: [
      {
        heading: 'Our Mission',
        content: "We believe everyone deserves a fair deal.\n\nThat's why we do things differently.",
        list: ['Transparent pricing', 'No pressure sales', 'Community focused'],
        subsections: [],
      },
    ],
    description: '<p>This is demo content shown when the site is loaded in demo mode.</p>',
  },
};
